export default __webpack_public_path__ + "media/globe.58672355.svg";